module.exports = __webpack_public_path__ + "img/Abstract-eposter.e2055fed.svg";